import { SENDER_IDENTITY_LABELS } from "@/components/SenderIdentitySelect";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "@a7y/tailwind-catalyst";
import type { ProductEmailSenderIdentity } from "../types";

interface ConfirmSendDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
  subject: string;
  senderIdentity: ProductEmailSenderIdentity;
  recipientCount: number;
}

export function ConfirmSendDialog({
  open,
  onClose,
  onConfirm,
  isPending,
  subject,
  senderIdentity,
  recipientCount,
}: ConfirmSendDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} size="sm">
      <DialogTitle>Confirm Send</DialogTitle>
      <DialogBody>
        <div className="space-y-4">
          <div className="rounded-lg bg-amber-50 p-4 text-sm text-amber-800 dark:bg-amber-900/20 dark:text-amber-300">
            Are you sure you want to send this email? This action cannot be
            undone.
          </div>

          <dl className="space-y-3 text-sm">
            <div className="flex justify-between">
              <dt className="text-zinc-500 dark:text-zinc-400">Subject</dt>
              <dd className="font-medium text-zinc-900 dark:text-white">
                {subject}
              </dd>
            </div>
            <div className="flex justify-between">
              <dt className="text-zinc-500 dark:text-zinc-400">Sender</dt>
              <dd className="font-medium text-zinc-900 dark:text-white">
                {SENDER_IDENTITY_LABELS[senderIdentity]}
              </dd>
            </div>
            <div className="flex justify-between">
              <dt className="text-zinc-500 dark:text-zinc-400">Recipients</dt>
              <dd className="font-medium text-zinc-900 dark:text-white">
                {recipientCount} {recipientCount === 1 ? "user" : "users"}
              </dd>
            </div>
          </dl>
        </div>
      </DialogBody>
      <DialogActions>
        <Button plain onClick={onClose}>
          Cancel
        </Button>
        <Button color="red" disabled={isPending} onClick={onConfirm}>
          {isPending ? "Sending..." : `Send to ${recipientCount} recipients`}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
